<template>
    <div class="common-seach-wrap">
        <el-tabs size="small" type="card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.value" :name="item.key" ></el-tab-pane>
        </el-tabs>
        <VR v-if="activeName === 'vr'" />
        <Comment v-if="activeName === 'comment'" />
        <Sign v-if="activeName === 'sign'" />
        <Setting v-if="activeName === 'setting'" />
    </div>
</template>
<script>
    import VR from './vr/index';
    import Setting from './setting/index';
    import Comment from './comment/index';
    import Sign from './sign/index';
    export default {
        components: {
            Setting,
            VR,
            Comment,
            Sign,
        },
        data() {
            return {
                /*当前选中*/
                activeName: 'vr',
                /*切换数组原始数据*/
                sourceList: [
                    {
                        key: 'vr',
                        value: 'VR面板',
                        path:'/education/vr/index'
                    },
                    {
                        key: 'sign',
                        value: '签名列表',
                        path:'/education/vr/signList'
                    },
                    {
                        key: 'comment',
                        value: '评论列表',
                        path:'/education/vr/commentList'
                    },
                    {
                        key: 'setting',
                        value: 'VR设置',
                        path:'/education/vr/setVr'
                    },
                ],
                /*权限筛选后的数据*/
                tabList:[],
            };
        },
        created() {
            this.tabList=this.authFilter();
            if (this.$route.query.type != null) {
                this.activeName = this.$route.query.type;
            }
        },

        methods: {
            handleClick(e) {
                this.activeName = e.name;
            },

            /*权限过滤*/
            authFilter(){
                let list=[];
                for(let i=0;i<this.sourceList.length;i++){
                    let item=this.sourceList[i];
                    if(this.$filter.isAuth(item.path)){
                        list.push(item);
                    }
                }
                return list;
            },

        }
    };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/education/vr/index.vue